import { put, takeLatest, fetch, all, apply, call } from '@ers/helpers/redux/sagaEffects';
import { USER_SIGNED_OUT } from 'redux-oidc';

import config from '@ers/config';
import { history } from '@ers/helpers';
import ApiFactory from '@ers/api/ApiFactory';
import { SentryLogger as Sentry } from '@ers/errors';
import {
    ActionTypes,
    loadUserCompleted
} from './App.actions';
import AppApi from './App.api';
import { addError } from './toasts/toasts.actions';
import { resetApplications } from './home/Home.actions';
import { eventTypes } from './shared/data';


function* loadUser(api) {
    const userDataResponse = yield fetch(api, api.fetchUserData);
    if (userDataResponse.data) {
        const avatarResponse = yield fetch(api, api.fetchUserAvatar);
        if (avatarResponse.data) {
            try {
                // createObjectURL is not supported in every browsers
                userDataResponse.data.avatar = window.URL.createObjectURL(avatarResponse.data.blob);
            } catch (error) {
                // fallback for older browser versions if srcObject is not supported
                userDataResponse.data.srcObject = avatarResponse.data.blob;
                Sentry.error(error);
            }
        }
        yield put(loadUserCompleted({ payload: { userData: userDataResponse.data } }));
    }
}


function* confirmApplications(api, action) {
    const messages = {
        304: 'Ta aplikacja została już dodana',
        401: 'Aplikacja została już wcześniej skasowana i nie można jej dodać'
    };
    const { applicationIds } = action.payload;
    const responses = yield all(applicationIds.map(
        (id) => fetch(api, api.confirmApplication, [id])
    ));
    const statuses = responses.map(({ data }) => data);
    yield* displayToasts(messages, statuses);
    yield all([
        put(resetApplications()),
        call(loadUser, api)
    ]);
    history.push('/');
}

function* denyApplications(api, action) {
    const messages = {
        401: 'Ta aplikacja została już usunięta',
        403: 'Aplikacja została już wcześniej dodana i nie można jej skasować'
    };
    const { applicationIds } = action.payload;
    const responses = yield all(applicationIds.map(
        (id) => fetch(api, api.denyApplication, [id])
    ));
    const statuses = responses.map(({ data }) => data);
    yield* displayToasts(messages, statuses);
    history.push('/');
}

function* displayToasts(messages, statuses) {
    const errors = [];
    Object.keys(messages).forEach((status) => {
        const parsed = parseInt(status);
        if (statuses.includes(parsed)) {
            errors.push(put(addError(messages[status], 5)));
        }
    });
    if (errors.length) {
        yield all(errors);
    }
}

function* sendEvent(api, action) {
    const { name, data } = action.payload;
    yield fetch(api, api.sendEvent, [name, data]);
}

function* sendAdvicesClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.advices, data: {} } });
}

function* sendAddApplicationClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.addApplicationBtn, data: {} } });
}
function* sendCreatorClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.creator, data: {} } });
}

function* sendAddApplicationContinueBtnEvent(api, action) {
    const { data } = action.payload;
    yield call(sendEvent, api, { payload: { name: eventTypes.addApplicationContinueBtn, data } });
}

function* sendEarningsClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.earnings, data: {} } });
}

function* sendPracujClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.pracuj, data: {} } });
}

function* sendTheProtocolClickedEvent(api, action) {
    yield call(sendEvent, api, { payload: { name: eventTypes.theprotocol, data: {} } });
}

function signout() {
    window.location.href = config.authorization.post_logout_redirect_uri;
}


export default function* appSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(USER_SIGNED_OUT, signout);
    yield takeLatest(ActionTypes.loadUser, loadUser, appApi);
    yield takeLatest(ActionTypes.confirmApplications, confirmApplications, appApi);
    yield takeLatest(ActionTypes.denyApplications, denyApplications, appApi);
    yield takeLatest(ActionTypes.sendEvent, sendEvent, appApi);
    yield takeLatest(ActionTypes.sendAdvicesClickedEvent, sendAdvicesClickedEvent, appApi);
    yield takeLatest(ActionTypes.sendAddApplicationClickedEvent, sendAddApplicationClickedEvent, appApi);
    yield takeLatest(ActionTypes.sendAddApplicationContinueBtnEvent, sendAddApplicationContinueBtnEvent, appApi);
    yield takeLatest(ActionTypes.sendCreatorClickedEvent, sendCreatorClickedEvent, appApi);
    yield takeLatest(ActionTypes.sendEarningsClickedEvent, sendEarningsClickedEvent, appApi);
    yield takeLatest(ActionTypes.sendPracujClickedEvent, sendPracujClickedEvent, appApi);
    yield takeLatest(ActionTypes.sendTheProtocolClickedEvent, sendTheProtocolClickedEvent, appApi);
}
